import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";

@Injectable({
  providedIn: 'root'
})
export class AircraftUsedService {
  constructor(private firestore: AngularFirestore) {}

  async getItems(userId: string) {
    return this.firestore.collection('users').doc(userId).collection('aircraft_used', ref => ref.orderBy('sort', 'desc')).snapshotChanges();
  }

  async createItem(data: any, userId: string) {
    let result = await this.firestore.collection('users').doc(userId).collection('aircraft_used').add(data);
    return result;
  }

  updateItem(id: any, sort: number, userId: string) {
    return this.firestore.collection('users').doc(userId).collection('aircraft_used').doc(id).update({
      sort: sort,
    });
  }

  async deleteItem(id: any, userId: string) {
    return this.firestore.collection('users').doc(userId).collection('aircraft_used').doc(id).delete();
  }
}
